import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import ModernHeader from '../components/modern/ModernHeader';
import ModernFooter from '../components/modern/ModernFooter';
import LoteDetalleContent from '../components/LoteDetalleContent';
import { api } from '../services/api';

const LoteDetallePage = () => {
  const { numeroLote } = useParams();
  const navigate = useNavigate();
  const [lote, setLote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchLote = async () => {
      try {
        setLoading(true);
        const data = await api.getLoteDetalle(numeroLote);
        setLote(data);
      } catch (error) {
        console.error('Error fetching lote:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLote();
  }, [numeroLote]);

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `Lote #${lote.numero_lote} - ${lote.categoria}`,
        text: `${lote.cabezas} cabezas - ${lote.departamento}`,
        url: window.location.href,
      }).catch(console.error);
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Enlace copiado al portapapeles');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <ModernHeader scrollY={100} />
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <Loader2 className="w-12 h-12 animate-spin text-green-600 mx-auto mb-4" />
            <p className="text-gray-600">Cargando lote...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!lote) {
    return (
      <div className="min-h-screen bg-gray-50">
        <ModernHeader scrollY={100} />
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <p className="text-gray-600 text-xl">Lote no encontrado</p>
            <button
              onClick={() => navigate('/lotes')}
              className="mt-4 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors"
            >
              Volver a Lotes
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <ModernHeader scrollY={100} />

      <div className="container mx-auto px-4 py-6 mt-20 max-w-[1600px]">
        {/* Botón volver */}
        <button
          onClick={() => {
            if (lote?.remate_numero) {
              navigate(`/lotes?remate=${lote.remate_numero}`);
            } else {
              navigate('/lotes');
            }
          }}
          className="mb-3 flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          {lote?.remate_numero ? `Volver al Remate ${lote.remate_numero}` : 'Volver a Lotes'}
        </button>

        {/* Componente de contenido reutilizable */}
        <LoteDetalleContent
          lote={lote}
          onShare={handleShare}
          showHeader={true}
          showButtons={true}
        />
      </div>

      <ModernFooter />
    </div>
  );
};

export default LoteDetallePage;
